import * as React from 'react';
import injectSheet from 'react-jss';
import { Icon, Modal } from 'antd';
import moment from 'moment';

const popupVisibleKey = '__POPUP_VISIBLE__';

const styles = theme => ({});

class DiwaliPopup extends React.PureComponent<any, any>{

  state: any = {
    isModalVisible: false,
  };

  componentDidMount() {
    this.checkForShow();
  }

  checkForShow = () => {
    const startDate = moment('2019-10-25').startOf('day');
    const endDate = moment('2019-10-28').endOf('day');
    const show = moment().isBetween(startDate, endDate);
    if (show && !window.localStorage.getItem(popupVisibleKey)) {
      this.setState({ isModalVisible: true });
    }
  }

  handleClose = () => {
    window.localStorage.setItem(popupVisibleKey, 'done');
    this.setState({ isModalVisible: false });
  }

  render() {
    const { isModalVisible } = this.state;
    const { classes } = this.props;
    return <div className={classes.modalParent}>
      <Modal footer={null} visible={isModalVisible}
      bodyStyle={{ padding: 0 }}
      width={640}
      destroyOnClose={true}
      onCancel={this.handleClose}
      closable={false}
      >
        <Icon type="close" onClick={this.handleClose} style={{
          position: 'absolute',
          color: '#ffffff',
          cursor: 'pointer',
          fontSize: '20px',
          top: '-25px',
          right: 0,
        }}/>
        {/* tslint:disable */}
        <img style={{ height: 'auto', width: '100%' }}
        src="https://shipsy-public-assets.s3-us-west-2.amazonaws.com/Diwali_PopUp+Copy+2.png"/>
      </Modal>
    </div>;
  }
}

const DiwaliPopupStyled = injectSheet(styles)(DiwaliPopup);
export default DiwaliPopupStyled;
